// Generated from SVG to Code Figma Plugin

export const ProductLineView = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.7992 10.8002V5.7002C19.7992 4.87177 19.1277 4.2002 18.2992 4.2002H5.69922C4.87079 4.2002 4.19922 4.87177 4.19922 5.7002V18.3002C4.19922 19.1286 4.87079 19.8002 5.69922 19.8002H10.7992"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16 19.0029C17.6569 19.0029 19 17.6598 19 16.0029C19 14.3461 17.6569 13.0029 16 13.0029C14.3431 13.0029 13 14.3461 13 16.0029C13 17.6598 14.3431 19.0029 16 19.0029Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M18.5 18L21 20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
  </svg>
);
